import React from 'react';

import { theme as VeeqoTheme } from 'Theme';
import { buildThemeVariables } from './utils';

/**
 * Component that injects a theme into the DOM as CSS variables. Only one instance per page is necessary
 *
 * The theme variables are mapped from dot-notation with camelCase property names, into kebab-case CSS variables.
 *
 * For example, `theme.text.headingLarge.fontSize` can be accessed as `var(--text-heading-large-font-size)`.
 */
type ThemeInjectorProps = {
  theme?: typeof VeeqoTheme;
};

export const ThemeInjector = React.memo(({ theme = VeeqoTheme }: ThemeInjectorProps) => {
  const themeStyle = buildThemeVariables(theme);

  return (
    <style>
      {`:root {${Object.entries(themeStyle)
        .map(([key, value]) => `${key}: ${value};`)
        .join('')}}`}
    </style>
  );
});
